export enum PartnerAccountType {
  AFFILIATE = 'affiliate',
  MEDIABUY = 'mediabuy',
  INTERNAL = 'internal'
}
